export default {
  "avg": require("./assets/team_avatars/average.png").default,
  "1": require("./assets/team_avatars/alien.png").default,
  "2": require("./assets/team_avatars/anchor.png").default,
  "3": require("./assets/team_avatars/arrow.png").default,
  "4": require("./assets/team_avatars/bicycle.png").default,
  "5": require("./assets/team_avatars/bomb.png").default,
  "6": require("./assets/team_avatars/bonfire.png").default,
  "7": require("./assets/team_avatars/cactus.png").default,
  "8": require("./assets/team_avatars/carrot.png").default,
  "9": require("./assets/team_avatars/clouds-and-sun.png").default,
  "10": require("./assets/team_avatars/cloudyrainbow.png").default,
  "11": require("./assets/team_avatars/clover-leaf.png").default,
  "12": require("./assets/team_avatars/colour.png").default,
  "13": require("./assets/team_avatars/compass.png").default,
  "14": require("./assets/team_avatars/crown.png").default,
  "15": require("./assets/team_avatars/diamond.png").default,
  "16": require("./assets/team_avatars/dinosaur.png").default,
  "17": require("./assets/team_avatars/earth-globe.png").default,
  "18": require("./assets/team_avatars/earth.png").default,
  "19": require("./assets/team_avatars/fatspaceship.png").default,
  "20": require("./assets/team_avatars/fatsun.png").default,
  "21": require("./assets/team_avatars/flag.png").default,
  "22": require("./assets/team_avatars/flower.png").default,
  "23": require("./assets/team_avatars/glacier.png").default,
  "24": require("./assets/team_avatars/greek-temple.png").default,
  "25": require("./assets/team_avatars/hammer.png").default,
  "26": require("./assets/team_avatars/hands.png").default,
  "27": require("./assets/team_avatars/horn.png").default,
  "28": require("./assets/team_avatars/hourglass.png").default,
  "29": require("./assets/team_avatars/justice.png").default,
  "30": require("./assets/team_avatars/knot.png").default,
  "31": require("./assets/team_avatars/lotus-flower.png").default,
  "32": require("./assets/team_avatars/maya.png").default,
  "33": require("./assets/team_avatars/medal.png").default,
  "34": require("./assets/team_avatars/monstera-leaf.png").default,
  "35": require("./assets/team_avatars/moon-landing.png").default,
  "36": require("./assets/team_avatars/newtons-cradle.png").default,
  "37": require("./assets/team_avatars/origami.png").default,
  "38": require("./assets/team_avatars/palm-tree.png").default,
  "39": require("./assets/team_avatars/pigeon.png").default,
  "40": require("./assets/team_avatars/pine-tree.png").default,
  "41": require("./assets/team_avatars/pineapple.png").default,
  "42": require("./assets/team_avatars/pirate-flag.png").default,
  "43": require("./assets/team_avatars/planet.png").default,
  "44": require("./assets/team_avatars/plum.png").default,
  "45": require("./assets/team_avatars/prize.png").default,
  "46": require("./assets/team_avatars/pyramid.png").default,
  "47": require("./assets/team_avatars/rainbow.png").default,
  "48": require("./assets/team_avatars/recycle.png").default,
  "49": require("./assets/team_avatars/red-berries.png").default,
  "50": require("./assets/team_avatars/redflower.png").default,
  "51": require("./assets/team_avatars/redsnowflake.png").default,
  "52": require("./assets/team_avatars/reforestation.png").default,
  "53": require("./assets/team_avatars/ship.png").default,
  "54": require("./assets/team_avatars/snowflake.png").default,
  "55": require("./assets/team_avatars/snowman.png").default,
  "56": require("./assets/team_avatars/spaceship.png").default,
  "57": require("./assets/team_avatars/sprout.png").default,
  "58": require("./assets/team_avatars/storm.png").default,
  "59": require("./assets/team_avatars/world.png").default,
  "60": require("./assets/team_avatars/strawberry.png").default,
  "61": require("./assets/team_avatars/sun.png").default,
  "62": require("./assets/team_avatars/swords.png").default,
  "63": require("./assets/team_avatars/trumpet.png").default,
  "64": require("./assets/team_avatars/ufo.png").default,
  "65": require("./assets/team_avatars/viking-ship.png").default,
  "66": require("./assets/team_avatars/volcano.png").default,
  "67": require("./assets/team_avatars/vortex.png").default,
  "68": require("./assets/team_avatars/water.png").default,
  "69": require("./assets/team_avatars/white-flag.png").default,
  "70": require("./assets/team_avatars/wind-mill.png").default,
};
